module.exports = __webpack_public_path__ + "static/img/wisdomnew.f4de2922.png";